module.exports = __webpack_public_path__ + "media/images/icons/vendors/large/entertainment-a662ab4e48fa3ec2a3741223c0b748f2.png";